import { useDownloadFile } from '@features/invoices/hooks/use-download-file/useDownloadFile';

import type {
  UseDownloadCreditMemoParams,
  UseDownloadCreditMemoReturn,
} from './useDownloadCreditMemo.types';

export function useDownloadCreditMemo({
  creditMemoId,
  creditMemoNumber,
}: UseDownloadCreditMemoParams): UseDownloadCreditMemoReturn {
  return useDownloadFile({
    id: creditMemoId,
    filename: `credit-${creditMemoNumber}.pdf`,
    errorMessage: 'Downloading the credit memo failed, please try again.',
  });
}
